import { Box, Button } from 'src/viewLayer/components/DesignSystem';
import { useParams } from 'react-router-dom';

import { t } from 'src/viewLayer/helpers/translations';
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream';
import './index.scss';

interface HandleButtonClickProps {
  learnLang: string;
  goToNextNode(): void;
  pageType: string;
}

interface InfoPageFooterProps {
  goToNextNode(): void;
  buttonTranslationKey: string;
  pageType: string;
}

const handleButtonClick = ({ goToNextNode, learnLang, pageType }: HandleButtonClickProps): void => {
  trackGuiInteracted({ learnLang, guiElementName: `${ pageType }_info_continue_button` });
  goToNextNode();
};

export default ({ goToNextNode, buttonTranslationKey, pageType }: InfoPageFooterProps): JSX.Element => {
  const { learnLang } = useParams();

  return (
    <Box className="InfoPageFooter">
      <Button
        data-testid="info-page-button"
        id="continue"
        onClick={ (): void => handleButtonClick({ goToNextNode, learnLang, pageType }) }
        size="jumbo"
        fullWidth
      >
        { t(buttonTranslationKey) }
      </Button>
    </Box>
  );
};
